// src/components/discovery/DedupChip.jsx
// Color-coded chip for the 4 dedup states.

import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { FS } from '../../theme/tokens';

const CONFIG = {
  new: {
    label: 'New',
    color: 'success',
    tooltip: 'No existing competitor or target — ready to onboard.',
  },
  competitor_exists: {
    label: 'Known shop',
    color: 'info',
    tooltip: 'Shop is already a competitor. A new product target will be created.',
  },
  target_exists: {
    label: 'Already tracked',
    color: 'default',
    tooltip: 'This SKU is already being scraped from this shop.',
  },
  url_collision: {
    label: 'URL conflict',
    color: 'warning',
    tooltip: 'This product URL already exists on another active target.',
  },
};

export default function DedupChip({ dedupStatus }) {
  const cfg = CONFIG[dedupStatus] || {
    label: dedupStatus || '—',
    color: 'default',
    tooltip: '',
  };

  return (
    <Tooltip title={cfg.tooltip} arrow>
      <Chip
        label={cfg.label}
        color={cfg.color}
        size="small"
        sx={{ fontSize: FS.xs, height: 20, fontWeight: 500 }}
      />
    </Tooltip>
  );
}
